import { createApp } from 'vue'
import App from '@/App.vue'
import './registerServiceWorker'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import router from '@/router'
import { store } from '@/store'
import { createI18n } from 'vue-i18n'
import VueCookies from 'vue3-cookies'
import locales from '@/locales/index'

// import axios, { AxiosRequestConfig } from 'axios'
// import webConfig from '@/config/web.config'

// axios.interceptors.request.use((request: AxiosRequestConfig) => {
//   if (request.headers !== undefined) {
//     request.headers.apiKey = 'fusion'
//   }
//   console.log('request : ' + request)
//   return request
// })

// i18n init
const i18n = createI18n({
  locale: store.state.locale,
  messages: {
    ...locales
  }
})

createApp(App).use(i18n).use(store).use(router).use(VueCookies).mount('#app')
